import { customAlphabet } from "nanoid";

//source: https://github.com/CyberAP/nanoid-dictionary/blob/master/src/dictionary.js
const lowercase = "abcdefghijklmnopqrstuvwxyz";
const numbers = "0123456789";

//https://zelark.github.io/nano-id-cc/
//8M IDs needed, in order to have a 1% probability of at least one collision.
const lowercaseRandomString = customAlphabet(lowercase + numbers, 10);

export const generateId: () => string = () => lowercaseRandomString();
